'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.Menu = Menu;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('@material-ui/core/styles');

var _List = require('@material-ui/core/List');

var _List2 = _interopRequireDefault(_List);

var _ListItem = require('@material-ui/core/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

var _Button = require('../Button');

var _Typography = require('../Typography');

var _menu = require('../../schema/component/menu.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


// Lazy Load
var ArrowDropDownIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/ArrowDropDown');
});
var ExpandMoreIcon = (0, _react.lazy)(function () {
  return import('@material-ui/icons/ExpandMore');
});

var useStyles = (0, _styles.makeStyles)({
  wrapper: {
    boxShadow: function boxShadow(_ref) {
      var isVisible = _ref.isVisible;
      return isVisible ? '0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)' : 'none';
    },
    borderRadius: '4px',
    transition: '0.1s'
  },
  list: {
    backgroundColor: 'var(--onprimary-high-emphasis)',
    boxShadow: function boxShadow(_ref2) {
      var listBoxShadow = _ref2.listBoxShadow;
      return listBoxShadow;
    },
    maxHeight: function maxHeight(_ref3) {
      var listHeight = _ref3.listHeight,
          isVisible = _ref3.isVisible;
      return isVisible ? listHeight || 'initial' : '0px';
    },
    borderRadius: '4px',
    overflowY: function overflowY(_ref4) {
      var isVisible = _ref4.isVisible;
      return isVisible ? 'scroll' : 'hidden';
    },
    padding: function padding(_ref5) {
      var isVisible = _ref5.isVisible;
      return isVisible ? '8px 0px' : '0px';
    },
    transition: '0.1s',

    borderTop: function borderTop(_ref6) {
      var isSelectDropdownBackground = _ref6.isSelectDropdownBackground,
          isVisible = _ref6.isVisible;
      return isVisible && !isSelectDropdownBackground ? '1px solid var(--outline)' : '0px';
    },
    borderTopRightRadius: function borderTopRightRadius(_ref7) {
      var isBorderRadiusFull = _ref7.isBorderRadiusFull;
      return isBorderRadiusFull ? '4px' : '0px';
    },
    borderTopLeftRadius: function borderTopLeftRadius(_ref8) {
      var isBorderRadiusFull = _ref8.isBorderRadiusFull;
      return isBorderRadiusFull ? '4px' : '0px';
    }
  },
  item: {
    cursor: 'pointer',
    height: function height(_ref9) {
      var itemHeight = _ref9.itemHeight;
      return itemHeight;
    }
  },
  itemSelected: {
    background: 'var(--overlay)',
    cursor: 'pointer',
    height: function height(_ref10) {
      var itemHeight = _ref10.itemHeight;
      return itemHeight;
    }
  },
  icon: {
    color: 'var(--onsurface-inactive)'
  },
  input: {
    alignItems: 'center',
    background: function background(_ref11) {
      var isSelectDropdownBackground = _ref11.isSelectDropdownBackground,
          isVisible = _ref11.isVisible;
      return isSelectDropdownBackground && isVisible ? 'var(--overlay)' : 'var(--onprimary-high-emphasis)';
    },
    border: function border(_ref12) {
      var isVisible = _ref12.isVisible;
      return isVisible ? 'none' : '1px solid var(--outline)';
    },
    borderRadius: function borderRadius(_ref13) {
      var isSelectDropdownBackground = _ref13.isSelectDropdownBackground,
          isVisible = _ref13.isVisible;
      return isSelectDropdownBackground && isVisible ? '4px 4px 0px 0px' : '4px';
    },
    display: 'flex',
    height: '40px',
    overflow: 'hidden',
    transition: '0.1s'
  },
  inputDropdown: {
    alignItems: 'center',
    borderLeft: function borderLeft(_ref14) {
      var isSelectDropdownBorder = _ref14.isSelectDropdownBorder;
      return isSelectDropdownBorder ? '1px solid var(--outline)' : 'none';
    },
    cursor: 'pointer',
    display: 'flex',
    padding: '8px',
    '& svg': {
      color: 'var(--onsurface-inactive)',
      transform: function transform(_ref15) {
        var isVisible = _ref15.isVisible;
        return 'rotateZ(' + (isVisible ? 180 : 0) + 'deg)';
      },
      transition: '0.2s'
    }
  },
  inputPlaceholder: {
    padding: '10px 8px'
  },
  action: {
    height: '24px !important',
    padding: '0px 4px !important',
    '& .button-text': {
      alignItems: 'center',
      display: 'flex'
    }
  }
});

var MenuList = function MenuList(_ref16) {
  var data = _ref16.data,
      classess = _ref16.classess,
      itemProps = _ref16.itemProps,
      _onClick = _ref16.onClick,
      value = _ref16.value,
      variant = _ref16.variant,
      props = _objectWithoutProperties(_ref16, ['data', 'classess', 'itemProps', 'onClick', 'value', 'variant']);

  return _react2.default.createElement(
    _List2.default,
    _extends({
      component: 'div'
    }, props, {
      className: 'menu menu-' + variant + ' ' + classess.list
    }),
    (data || []).map(function (_ref17) {
      var Icon = _ref17.Icon,
          row = _objectWithoutProperties(_ref17, ['Icon']);

      var isSelected = row.value === (value && value.value);
      return _react2.default.createElement(
        _ListItem2.default,
        _extends({
          key: row.value,
          button: true
        }, itemProps, {
          className: isSelected ? classess.itemSelected : classess.item,
          onClick: function onClick() {
            return _onClick(_extends({}, row, { Icon: Icon }));
          }
        }),
        _react2.default.createElement(
          _Typography.Typography,
          { variant: 'textbody1-reguler' },
          row.label
        ),
        Icon && _react2.default.createElement(Icon, { className: classess.icon })
      );
    })
  );
};

MenuList.propTypes = {
  classess: _propTypes2.default.shape({
    container: _propTypes2.default.shape({}),
    icon: _propTypes2.default.shape({}),
    item: _propTypes2.default.shape({}),
    itemSelected: _propTypes2.default.shape({}),
    list: _propTypes2.default.shape({})
  }).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  itemProps: _propTypes2.default.shape({}).isRequired,
  onClick: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired,
  variant: _propTypes2.default.number.isRequired
};

function Menu(_ref18) {
  var data = _ref18.data,
      isVisible = _ref18.isVisible,
      itemProps = _ref18.itemProps,
      onClick = _ref18.onClick,
      placeholder = _ref18.placeholder,
      value = _ref18.value,
      variant = _ref18.variant,
      props = _objectWithoutProperties(_ref18, ['data', 'isVisible', 'itemProps', 'onClick', 'placeholder', 'value', 'variant']);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDropdown = _useState2[0],
      setIsDropdown = _useState2[1];

  var variantSelected = _menu.properties[variant] && _menu.properties[variant].properties || _menu.properties['dropdown-large'].properties;

  if (variantSelected.isDropdown) {
    var classess = useStyles({
      listBoxShadow: variantSelected.listBoxShadow,
      listHeight: variantSelected.listHeight,
      isVisible: isVisible,
      itemHeight: variantSelected.itemHeight
    });

    return _react2.default.createElement(MenuList, _extends({
      classess: classess,
      data: data,
      itemProps: itemProps,
      onClick: onClick,
      value: value,
      variant: variant
    }, props));
  }

  var onToggleDropdown = function onToggleDropdown() {
    return setIsDropdown(!isDropdown);
  };

  if (variantSelected.isSelectDropdown) {
    var _classess = useStyles({
      isSelectDropdownBorder: variantSelected.isSelectDropdownBorder,
      isSelectDropdownBackground: variantSelected.isSelectDropdownBackground,
      isVisible: isDropdown,
      itemHeight: variantSelected.itemHeight,
      listBoxShadow: variantSelected.listBoxShadow,
      listHeight: variantSelected.listHeight
    });

    var onSelectItem = function onSelectItem(payload) {
      onToggleDropdown();
      onClick(payload);
    };

    return _react2.default.createElement(
      'div',
      { className: _classess.wrapper },
      _react2.default.createElement(
        'div',
        { className: _classess.input },
        _react2.default.createElement(
          _Typography.Typography,
          { variant: 'textbody2-reguler', className: _classess.inputPlaceholder },
          value && value.label || placeholder
        ),
        _react2.default.createElement(
          'div',
          {
            className: _classess.inputDropdown,
            onClick: onToggleDropdown,
            onKeyPress: onToggleDropdown,
            role: 'button',
            tabIndex: '0'
          },
          _react2.default.createElement(
            _react.Suspense,
            { fallback: _react2.default.createElement('div', null) },
            _react2.default.createElement(ArrowDropDownIcon, null)
          )
        )
      ),
      _react2.default.createElement(MenuList, _extends({
        classess: _classess,
        data: data,
        itemProps: itemProps,
        onClick: onSelectItem,
        value: value,
        variant: variant
      }, props))
    );
  }

  if (variantSelected.isButton) {
    var _classess2 = useStyles({
      isBorderRadiusFull: variantSelected.isBorderRadiusFull,
      isSelectDropdownBorder: variantSelected.isSelectDropdownBorder,
      isSelectDropdownBackground: variantSelected.isSelectDropdownBackground,
      isVisible: isDropdown,
      itemHeight: variantSelected.itemHeight,
      listBoxShadow: variantSelected.listBoxShadow,
      listHeight: variantSelected.listHeight
    });

    var _onSelectItem = function _onSelectItem(payload) {
      onToggleDropdown();
      onClick(payload);
    };

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _Button.Button,
        {
          className: _classess2.action,
          textVariant: 'caption',
          type: 'text-primary',
          onClick: onToggleDropdown
        },
        _react2.default.createElement(
          'span',
          { 'data-margin-right': '4px' },
          placeholder
        ),
        _react2.default.createElement(
          _react.Suspense,
          { fallback: _react2.default.createElement('div', null) },
          _react2.default.createElement(ExpandMoreIcon, null)
        )
      ),
      _react2.default.createElement(MenuList, _extends({
        classess: _classess2,
        data: data,
        itemProps: itemProps,
        onClick: _onSelectItem,
        value: value,
        variant: variant,
        'data-margin-top': variantSelected.listMarginTop || '0px'
      }, props))
    );
  }

  if (variantSelected.isModal) {
    return _react2.default.createElement(
      'div',
      null,
      'Bottom Sheet'
    );
  }
}

Menu.defaultProps = {
  data: [],
  isVisible: false,
  itemProps: {},
  onClick: function onClick() {},
  placeholder: 'Silahkan Pilih',
  value: null,
  variant: 'dropdown-large'
};

Menu.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string,
    Icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({})])
  })),
  itemProps: _propTypes2.default.shape({}),
  onClick: _propTypes2.default.func,
  isVisible: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.shape({}),
  variant: _propTypes2.default.number
};

exports.default = Menu;